import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery, Link } from 'gatsby';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const BranchLinks = ({ branch, className, ...other }) => {
	const contentQuery = useStaticQuery(query);
	const showroomData = contentQuery.allShowrooms.nodes.filter((item) => item.state === branch.state?.abbreviation || branch.additional_showrooms?.includes(item.store_number));
	const newShowroomUrls = contentQuery.showroomUrls.nodes;

	const renderShowroomLinks = (showroom, index) => {
		const url = newShowroomUrls.find((item) => item.showroom_id === showroom.store_number)?.url;
		if (!url) return null;

		return (
			<li
				key={index}
				className='mb-4 mr-6'
			>
				<CTA
					data={{
						link: { href: url, title: showroom.city },
						button_style: 'tertiary',
						gtm_link_type: 'button',
					}}
				/>
			</li>
		);
	};

	return (
		<div
			className={`branchLinks ${className || ''}`}
			{...other}
		>
			<div>
				{branch.formal_name && <p className='mb-4 text-base font-bold tracking-wider md:text-lg'>{branch.branch_url ? <Link to={branch.branch_url}>{branch.formal_name}</Link> : branch.formal_name}</p>}
				<List
					bullets='none'
					layout='inline'
				>
					{isValidArray(showroomData) && <>{showroomData.filter((item) => branch.branch_retail?.includes(item.branch_id) || branch.additional_showrooms?.includes(item.store_number)).map((showroom, index) => renderShowroomLinks(showroom, index))}</>}
				</List>
			</div>
		</div>
	);
};

BranchLinks.propTypes = {
	branch: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default BranchLinks;

export const query = graphql`
	{
		allShowrooms {
			nodes {
				...Showroom
			}
		}

		showroomUrls: allContentstackBranchShowroom {
			nodes {
				url
				showroom_id
			}
		}
	}
`;
